import { render, staticRenderFns } from "./Enrollment.vue?vue&type=template&id=fed64bba&scoped=true"
import script from "./Enrollment.vue?vue&type=script&lang=js"
export * from "./Enrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed64bba",
  null
  
)

export default component.exports